import { BookOpen, FlaskConical, HeartPulse, LineChart } from "lucide-react";
import DATA from "@/data/vaseis2026.json";

export const FIELDS = [
  { id: 1, short: "1ο Πεδίο", name: "Ανθρωπιστικές, Νομικές & Κοινωνικές Επιστήμες", icon: BookOpen, color: "#B45309", subjects: ["Νεοελληνική Γλώσσα", "Αρχαία Ελληνικά", "Ιστορία", "Λατινικά"] },
  { id: 2, short: "2ο Πεδίο", name: "Θετικές & Τεχνολογικές Επιστήμες", icon: FlaskConical, color: "#0A1A4A", subjects: ["Νεοελληνική Γλώσσα", "Φυσική", "Χημεία", "Μαθηματικά"] },
  { id: 3, short: "3ο Πεδίο", name: "Επιστήμες Υγείας & Ζωής", icon: HeartPulse, color: "#B91C1C", subjects: ["Νεοελληνική Γλώσσα", "Φυσική", "Χημεία", "Βιολογία"] },
  { id: 4, short: "4ο Πεδίο", name: "Επιστήμες Οικονομίας & Πληροφορικής", icon: LineChart, color: "#047857", subjects: ["Νεοελληνική Γλώσσα", "Μαθηματικά", "Πληροφορική", "Οικονομία"] },
];

export const SCHOOLS_BY_FIELD = (() => {
  const m = { 1: [], 2: [], 3: [], 4: [] };
  DATA.forEach((s) => s.f.forEach((f) => m[f] && m[f].push(s)));
  Object.values(m).forEach((arr) => arr.sort((a, b) => b.b - a.b));
  return m;
})();

export const fmt = (n) => (n == null ? "—" : n.toLocaleString("el-GR"));
